import styled from 'styled-components';

// To be used when a ModalFooter is needed in a flex-styled Modal
const ModalBody = styled.div``;

export default ModalBody;
